import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { EmptyStatePanel } from '@/components/common/EmptyStatePanel';
import { getAIEngineeringActionLabel, getAIEngineeringStatusLabel, getAIEngineeringStatusTone } from '@/lib/aiEngineeringLabels';

export const AIEngineeringTaskTimeline = ({ task }) => {
  if (!task?.runs?.length) {
    return <EmptyStatePanel title="Timeline vazia" description="Os eventos do fluxo AI Engineering aparecem aqui assim que uma task for criada." ctaLabel={null} testId="ai-engineering-empty-timeline" />;
  }

  const orderedRuns = [...task.runs].reverse();

  return (
    <Card className="border-slate-200 shadow-sm" data-testid="ai-engineering-timeline-panel">
      <CardHeader className="pb-3">
        <CardTitle className="text-base font-semibold text-slate-900">Timeline / Runs</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 border-l border-slate-200 pl-4">
          {orderedRuns.map((run) => (
            <div key={run.id} className="relative rounded-sm border border-slate-200 bg-white p-3">
              <span className="absolute -left-[22px] top-4 h-2.5 w-2.5 rounded-full bg-slate-900" />
              <div className="flex flex-col gap-2 xl:flex-row xl:items-center xl:justify-between">
                <div>
                  <p className="text-sm font-semibold text-slate-900">{getAIEngineeringActionLabel(run.action)}</p>
                  <p className="text-xs text-slate-500">{run.summary}</p>
                </div>
                <Badge variant="outline" className={`w-fit rounded-sm border ${getAIEngineeringStatusTone(run.status_after)}`}>{getAIEngineeringStatusLabel(run.status_after)}</Badge>
              </div>
              <div className="mt-2 flex flex-wrap gap-3 text-[11px] text-slate-500">
                <span>{run.performed_by_name || 'Operador interno'}</span>
                <span>{new Date(run.created_at).toLocaleString('pt-PT', { timeZone: 'Africa/Maputo' })}</span>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};